/**
 * The approved Davnai mark is supplied by the owner as artwork. Keep the PNG
 * intact so its ribbon geometry, shading and highlights are never approximated
 * by the application. All shared page logos consume this one public asset.
 */
export const LOGO_MARK_SRC = "/brand/davnai-mark.png";
export const LOGO_MARK_WIDTH = 512;
export const LOGO_MARK_HEIGHT = 512;
